import Link from "next/link";
import Image from "next/image";
import LogoLimrun from "@/public/logo-gradient.svg";

export default function Logo() {
  return (
    <Link href="/" className="inline-flex" aria-label="Limrun">
      <div className="flex items-center">
        <Image
          className="relative"
          src={LogoLimrun}
          width={32}
          height={32}
          alt="Logo"
          priority
        />
        <span className="text-xl font-bold text-gray-900 ml-1">limrun</span>
      </div>
    </Link>
  );
}
